import { ActivityLessonPlanPreview } from "@/components/home/ActivityLessonPlanPreview";
import { FrameworkPreview } from "@/components/home/FrameworkPreview";
import { Hero } from "@/components/home/Hero";
import { PopularCompetencies } from "@/components/home/PopularCompetencies";
import { Testimonials } from "@/components/home/Testimonials";
import { AntiHero } from "@/components/home/AntiHero";
import { withLayout } from "@/components/withLayout";
import { Events } from "@/components/home/Events";

const HomePage = () => {
  return (
    <div className="flex flex-col gap-y-16 medium:gap-y-36">
      <Hero />
      <PopularCompetencies />
      <ActivityLessonPlanPreview />
      <FrameworkPreview />
      <Testimonials />
      <Events />
      <AntiHero />
    </div>
  );
};

export default withLayout(HomePage);
